// extracted by mini-css-extract-plugin
export default {"loading-full-page":"style_loading-full-page__VpC-K"};